import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footerimg from "../../Assets/FooterImg/Foterimg.webp";
import HaveAQuestion from "../User/Rental/HavaAQuestion";
import { GrInstagram } from "react-icons/gr";
import { FiFacebook, FiYoutube } from "react-icons/fi";
import AOS from "aos";
import "aos/dist/aos.css";

const UserFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fallbackData = {
    no1: "(678) 287-1100",
    no2: "(678) 714-7454",
    no3: "(470) 513-2256",
    whatsappNo: "(404) 200-2954",
    email: "info@sports&strike.com",
    address: "4285 Brogdon Exchange NW\nSuwanee, GA 30024",
    socialLinks: { instagram: "#", facebook: "#", youtube: "#" },
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: true, easing: "ease-out" });

    const fetchContactData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/contactinfo/get-contact`,
        );
        if (response.data?.success && response.data?.data) {
          setContactData(response.data.data);
        } else {
          setContactData(fallbackData);
        }
      } catch (error) {
        console.error("Error fetching contact data:", error);
        setContactData(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();
  }, []);

  const navLinks = [
    [
      { label: "RENTALS", path: "/rental" },
      { label: "ABOUT", path: "/about" },

      // { label: "MEMBERSHIPS", path: "/membership" },
      { label: "ACADEMIES", path: "/sports-academy" },
    ],
    [
      { label: "LEAGUES", path: "/leagues" },
      { label: "EAT & DRINK", path: "/bar-and-restaurant" },
      { label: "CONTACT", path: "/contact" },
    ],
  ];

  return (
    <>
      <HaveAQuestion />
      <footer
        className="w-full bg-cover bg-center bg-no-repeat text-white relative min-h-[400px] sm:min-h-[450px] lg:min-h-[500px] flex flex-col overflow-hidden"
        style={{ backgroundImage: `url(${Footerimg})` }}
      >
        <div className="bg-opacity-70 flex-1 py-8 sm:py-12 lg:py-20 px-4 sm:px-6 lg:px-12">
          <div className="w-full mx-auto h-full">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 h-full">
              {/* Left Section - Company Info */}
              <div
                data-aos="fade-right"
                className="lg:col-span-6 flex flex-col justify-center"
              >
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-white tracking-wide">
                  STRIKES & SHOTS
                </h3>
                <div className="space-y-3 sm:space-y-4 text-gray-300 mb-6 sm:mb-8">
                  <p className="text-base sm:text-lg leading-relaxed">
                    {(contactData?.address || fallbackData.address).replace(
                      /\n/g,
                      " | ",
                    )}
                  </p>
                  <p className="text-base sm:text-lg font-medium">
                    {contactData?.no1 || fallbackData.no1}{" "}
                    <span className="text-gray-100 opacity-40 text-xs sm:text-sm">
                      (Main)
                    </span>
                  </p>
                  <p className="text-base sm:text-lg font-medium">
                    {contactData?.no2 || fallbackData.no2}{" "}
                    <span className="text-gray-100 opacity-40 text-xs sm:text-sm">
                      (The DugOut)
                    </span>
                  </p>
                  <p className="text-base sm:text-lg font-medium">
                    {contactData?.no3 || fallbackData.no3}{" "}
                    <span className="text-gray-100 opacity-40 text-xs sm:text-sm">
                      (Cell)
                    </span>
                  </p>
                </div>

                {/* Navigation Links */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 sm:gap-x-12 gap-y-3 sm:gap-y-4 mb-6 sm:mb-8">
                  {navLinks.map((group, i) => (
                    <div key={i} className="space-y-2 sm:space-y-3">
                      {group.map((link) => (
                        <p
                          key={link.path}
                          onClick={() => {
                            navigate(link.path);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                          className="cursor-pointer hover:text-primaryBtnHoverColor transition-colors duration-200 text-gray-300 text-sm sm:text-base font-medium"
                        >
                          {link.label}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Section - Social Media */}
              <div
                data-aos="fade-left"
                className="lg:col-span-6 flex flex-col justify-center items-center lg:items-end"
              >
                <div className="flex flex-row lg:flex-col gap-4 sm:gap-6">
                  {["instagram", "facebook", "youtube"].map((platform) => {
                    const Icon =
                      platform === "instagram"
                        ? GrInstagram
                        : platform === "facebook"
                          ? FiFacebook
                          : FiYoutube;
                    return (
                      <a
                        key={platform}
                        href={contactData?.socialLinks?.[platform] || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 sm:w-12 sm:h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center cursor-pointer hover:bg-primaryBtnHoverColor transition-all duration-300 hover:scale-110"
                      >
                        <Icon className="text-white text-lg sm:text-xl" />
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-opacity-80 py-4 sm:py-6 px-4 sm:px-6 lg:px-12">
          <div className="w-full mx-auto">
            <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm gap-2 sm:gap-0">
              <div className="flex flex-col sm:flex-row items-center text-gray-400 text-center sm:text-left">
                <div className="flex justify-center items-center sm:block gap-1 sm:0">
                  <span className="mb-1 sm:mb-0 sm:mr-2">© {currentYear},</span>
                  <span className="mb-1 sm:mb-0 sm:mr-2">STRIKES & SHOTS</span>
                </div>
                <span className="text-gray-600">ALL RIGHTS RESERVED</span>
              </div>
              <div className="flex items-center text-gray-400">
                <span
                  onClick={() =>
                    window.open("https://www.webbocket.com/", "_blank")
                  }
                  className="text-gray-400 hover:text-white underline cursor-pointer transition-colors duration-200"
                >
                  Web_Bocket PVT LTD.
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default UserFooter;
